module.exports = __webpack_public_path__ + "static/media/view2.cbfdc1a1.jpg";